import { render, staticRenderFns } from "./JEllipsis.vue?vue&type=template&id=9919c00c&scoped=true&"
import script from "./JEllipsis.vue?vue&type=script&lang=js&"
export * from "./JEllipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9919c00c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9919c00c')) {
      api.createRecord('9919c00c', component.options)
    } else {
      api.reload('9919c00c', component.options)
    }
    module.hot.accept("./JEllipsis.vue?vue&type=template&id=9919c00c&scoped=true&", function () {
      api.rerender('9919c00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JEllipsis.vue"
export default component.exports